// extracted by mini-css-extract-plugin
export default {"advertDetailInfoLocation":"c-j_fK","advertDetailInfoLocation__value":"c-j_fL"};